import { ConversionConstructedNoDates } from "@/types/types";

export const isConversionMulti = (
  conversionMultConversionMaybe:
    | ConversionConstructedNoDates
    | ConversionConstructedNoDates[]
): conversionMultConversionMaybe is ConversionConstructedNoDates[] => {
  return Array.isArray(conversionMultConversionMaybe);
};
